import { a as applyMixins } from './apply-mixins.js';
import { A as AffixIconWithTrailing } from './affix.js';
import { V as VividElement, O as Observable, o as observable, a as attr } from './vivid-element.js';
import { i as isHTMLElement } from './dom.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
function isListboxOption(el) {
  return isHTMLElement(el) && (el.getAttribute("role") === "option" || el instanceof HTMLOptionElement);
}
class ListboxOption extends VividElement {
  constructor(text, value, defaultSelected, selected) {
    super();
    this.defaultSelected = false;
    /**
     * Tracks whether the "selected" property has been changed.
     * @internal
     */
    this.dirtySelected = false;
    this.selected = this.defaultSelected;
    /**
     * Track whether the value has been changed from the initial value
     */
    this.dirtyValue = false;
    this._highlighted = false;
    this._displayCheckmark = false;
    this._matchedRange = null;
    if (text) {
      this.text = text;
    }
    if (value) {
      this.initialValue = value;
    }
    if (defaultSelected) {
      this.defaultSelected = defaultSelected;
    }
    if (selected) {
      this.selected = selected;
    }
    this.proxy = new Option(
      this.text,
      // @ts-expect-error Propery is used before it is assigned
      this.initialValue,
      this.defaultSelected,
      this.selected
    );
    this.proxy.disabled = this.disabled;
  }
  defaultSelectedChanged() {
    if (!this.dirtySelected) {
      this.selected = this.defaultSelected;
      if (this.proxy instanceof HTMLOptionElement) {
        this.proxy.selected = this.defaultSelected;
      }
    }
  }
  disabledChanged() {
    if (this.proxy instanceof HTMLOptionElement) {
      this.proxy.disabled = this.disabled;
    }
  }
  selectedAttributeChanged() {
    this.defaultSelected = this.selectedAttribute;
    if (this.proxy instanceof HTMLOptionElement) {
      this.proxy.defaultSelected = this.defaultSelected;
    }
  }
  selectedChanged() {
    if (!this.dirtySelected) {
      this.dirtySelected = true;
    }
    if (this.proxy instanceof HTMLOptionElement) {
      this.proxy.selected = this.selected;
    }
  }
  initialValueChanged() {
    if (!this.dirtyValue) {
      this.value = this.initialValue;
      this.dirtyValue = false;
    }
  }
  get label() {
    return this._label ?? this.text;
  }
  set label(value) {
    this._label = value;
  }
  set text(value) {
    this._text = value;
  }
  get text() {
    return this._text ?? "";
  }
  set value(next) {
    const newValue = `${next ?? ""}`;
    this._value = newValue;
    this.dirtyValue = true;
    if (this.proxy instanceof HTMLOptionElement) {
      this.proxy.value = newValue;
    }
    Observable.notify(this, "value");
  }
  get value() {
    Observable.track(this, "value");
    return this._value ?? this.text;
  }
  get form() {
    return null;
  }
  /**
   * @internal
   */
  get _matchedRangeSafe() {
    return this._matchedRange ?? { from: 0, to: 0 };
  }
}
__decorateClass([
  observable
], ListboxOption.prototype, "checked");
__decorateClass([
  observable
], ListboxOption.prototype, "defaultSelected");
// @ts-expect-error Type is incorrectly non-optional
__decorateClass([
  attr({ mode: "boolean" })
], ListboxOption.prototype, "disabled");
// @ts-expect-error Type is incorrectly non-optional
__decorateClass([
  attr({ attribute: "selected", mode: "boolean" })
], ListboxOption.prototype, "selectedAttribute");
__decorateClass([
  observable
], ListboxOption.prototype, "selected");
__decorateClass([
  attr({ attribute: "value", mode: "fromView" })
], ListboxOption.prototype, "initialValue");
__decorateClass([
  attr({
    attribute: "label"
  })
], ListboxOption.prototype, "_label");
__decorateClass([
  attr({
    attribute: "text"
  })
], ListboxOption.prototype, "_text");
__decorateClass([
  observable
], ListboxOption.prototype, "_highlighted");
__decorateClass([
  observable
], ListboxOption.prototype, "_displayCheckmark");
__decorateClass([
  observable
], ListboxOption.prototype, "_matchedRange");
applyMixins(ListboxOption, AffixIconWithTrailing);

export { ListboxOption as L, isListboxOption as i };
